import React from 'react';

const EqControlPlan = React.lazy(() => import('./views/eq-control-plan/EqControlPlan'));
const Download = React.lazy(() => import('./views/download/Download'));
const ErrorPage = React.lazy(() => import('./views/err/errorPage'));
const ChangePassword = React.lazy(() => import('./views/pages/change-password/ChangePassword'));
const routes = [
  {
    path: '/err',
    exact: true,
    name: 'Error',
    component: ErrorPage,
  },
  { path: '/eq-control-plan', exact: true, name: 'EQ制御計画', component: EqControlPlan },
  { path: '/download', exact: true, name: 'ダウンロード', component: Download },
  { path: '/changePassword', exact: true, name: 'パスワード変更', component: ChangePassword },
];

export default routes;
